import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types/lib/DateFromUnixTime';
import { Status } from '@/entities/todo/constants';
import { authorizedTo, entityItem, group, id, meta, nullableUser, score, users } from '@/services/api';
import { recordCodec as issueRecordCodec } from '@/services/api/resources/issue/v2';
import { inspectionApprovalCodec } from '@/services/api/resources/approval';

const inspection = t.type({
  id,
  score,
  conductedAt: t.union([DateFromUnixTime, t.null]),
  percentage: t.union([t.number, t.null]),
  assignedGroups: t.array(group),
  approval: t.union([t.null, inspectionApprovalCodec]),
  system: t.type({
    rejected: t.boolean,
    reasonCode: t.union([t.string, t.null]),
  }),
});

export const data = t.type({
  title: t.string,
  inspectionTitle: t.union([t.string, t.undefined, t.null]),
  // to do status
  status: t.union([
    t.literal(Status.Pending),
    t.literal(Status.InProgress),
    t.literal(Status.Done),
    t.literal(Status.SystemRejected),
  ]),
  createdAt: DateFromUnixTime,
  dueAt: t.union([DateFromUnixTime, t.null]),
  doneAt: t.union([DateFromUnixTime, t.null]),
  updatedAt: t.union([DateFromUnixTime, t.null]),
  createdBy: nullableUser,
  doneBy: nullableUser,
  assignees: users,
  issues: t.array(issueRecordCodec),
  entityItem: t.union([entityItem, t.null]),
  inspectionCount: t.union([t.number, t.undefined]),
  inspection,
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

export const detailCodec = t.type({
  data,
  authorizedTo,
});

export const paginationCountCodec = t.type({
  data: t.type({
    total: t.number,
  }),
});

export const formCodec = t.type({ title: t.string });
